import { render, staticRenderFns } from "./ScanCanvas2.vue?vue&type=template&id=31f0bb2a&scoped=true&"
import script from "./ScanCanvas2.vue?vue&type=script&lang=js&"
export * from "./ScanCanvas2.vue?vue&type=script&lang=js&"
import style0 from "./ScanCanvas2.vue?vue&type=style&index=0&id=31f0bb2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0bb2a",
  null
  
)

export default component.exports